export default __webpack_public_path__ + "static/media/download-app.bac905fa.svg";